import * as React from "react";
import { Lightbulb, CircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
const faqs = [{
  question: "Do you provide loaner cars during repairs?",
  answer: "Yes, we understand that being without a vehicle is a major inconvenience. We offer a fleet of modern loaner cars for major service appointments to keep you moving while we work on your vehicle.",
  proTip: "Be sure to request a loaner car when booking your appointment, as they are subject to availability and tend to be reserved quickly during peak service weeks."
}, {
  question: "What kind of warranty do you offer on your work?",
  answer: "At Dott's Garage, we stand behind our century-long reputation. All our repairs come with a comprehensive 24-month or 24,000-mile nationwide warranty on both parts and labor.",
  proTip: "Keep your digital service record handy. Our warranty is honored at thousands of certified locations across the country, giving you peace of mind even when you're away from Albany."
}, {
  question: "How often should I really change my oil?",
  answer: "While the old rule was every 3,000 miles, modern synthetic oils and engine designs often allow for intervals between 5,000 and 7,500 miles depending on your driving habits and vehicle age.",
  proTip: "Check your owner's manual first, but if you frequently drive in stop-and-go Albany traffic, we recommend sticking to a more frequent schedule to prevent engine sludge buildup."
}, {
  question: "Can you service my brand new car without voiding the warranty?",
  answer: "Absolutely. It is a common misconception that you must go to the dealership. As long as we perform the maintenance according to the manufacturer's specifications, your factory warranty remains fully intact.",
  proTip: "We use OEM-equivalent parts and provide detailed documentation for every service, ensuring your vehicle's history is perfectly maintained for future resale value."
}, {
  question: "Why is my 'Check Engine' light on but the car feels fine?",
  answer: "The light can trigger for hundreds of reasons, from a loose gas cap to a failing oxygen sensor. Even if the car feels normal, the computer has detected an issue that could lead to poor fuel economy or damage.",
  proTip: "Don't ignore it. A simple diagnostic scan can often catch a minor $50 sensor issue before it turns into a $1,000 catalytic converter replacement."
}];
export default function ConsigliPro() {
  return <section data-section-id="224990" id="common-questions" className="relative w-full bg-background text-foreground py-16 md:py-24 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[30rem] h-[30rem] bg-chart-2/5 rounded-full blur-3xl translate-y-1/3 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="font-default text-3xl md:text-4xl font-bold tracking-tight text-primary uppercase mb-4">
            Common Questions
          </h2>
          <p className="font-default text-lg text-muted-foreground">
            Trusted automotive advice from Albany's local mechanics for over 100 years.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card border border-border rounded-md px-2 md:px-4 shadow-sm data-[state=open]:bg-card data-[state=open]:border-primary/20 transition-all duration-300">
                <AccordionTrigger className="text-base md:text-lg font-default font-semibold hover:no-underline py-5 text-left data-[state=open]:text-primary">
                  <span className="flex items-center gap-3">
                    <CircleQuestionMark className="h-5 w-5 text-primary/60 shrink-0" />
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted-foreground font-default leading-relaxed pb-6 pt-2 px-8">
                  <p className="mb-6">{faq.answer}</p>
                  
                  <Alert className="bg-secondary border-primary/10 shadow-none rounded-md">
                    <Lightbulb className="h-5 w-5 text-chart-2" />
                    <AlertTitle className="text-chart-2 font-default font-bold tracking-wider uppercase text-xs mb-1.5">
                      Expert Insight
                    </AlertTitle>
                    <AlertDescription className="text-primary font-medium">
                      {faq.proTip}
                    </AlertDescription>
                  </Alert>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}